import axios from 'axios';

const settings = {
  dev: {
    apiUrl: 'http://localhost:3030',
  },
  production: {
    apiUrl: 'https://translate-api.supakti.co.il',
    // apiUrl: 'https://translate-pdf-api-9fc47e074af4.herokuapp.com',
  },
};

export const getCurrentSettings = () => {
  if (process.env.NODE_ENV === 'development') return settings.dev;

  return settings.production;
};

const apiClient = axios.create({
  baseURL: getCurrentSettings().apiUrl,
  timeout: 14000, // 14 seconds
  headers: {
    Authorization: `Bearer `,
  },
});

export default apiClient;
